import user1 from '../images/carousel/user1.svg';
import user2 from '../images/carousel/user2.svg';
import user3 from '../images/carousel/user3.svg';
import user4 from '../images/carousel/user4.svg';

const data = [
    {
        id: 1,
        image: user1,
        description: 'Lorem ipsum dolor sit amet consectetur. Eu in quam lacus pellentesque eget ut. Morbi nisi diam dignissim arcu proin enim dui ornare neque. Turpis dolor at egestas consectetur urna. Malesuada velit purus id a vitae mauris mattis. Cursus blandit quam urna tempor semper feugiat.'
    },
    {
        id: 2,
        image: user2,
        description: 'Lorem ipsum dolor sit amet consectetur. Eu in quam lacus pellentesque eget ut. Morbi nisi diam dignissim arcu proin enim dui ornare neque. Turpis dolor at egestas consectetur urna. Malesuada velit purus id a '
    },
    {
        id: 3,
        image: user3,
        description: 'Lorem ipsum dolor sit amet consectetur. Eu in quam lacus pellentesque eget ut. Morbi nisi diam dignissim arcu proin enim dui ornare neque. Turpis dolor at egestas consectetur urna. Malesuada velit purus id a vitae mauris mattis. Cursus blandit quam urna tempor semper feugiat.'
    },
    {
        id: 4,
        image: user4,
        description: 'Lorem ipsum dolor sit amet consectetur. Eu in quam lacus pellentesque eget ut. Morbi nisi diam dignissim arcu proin enim dui ornare neque. Turpis dolor at egestas consectetur urna. Malesuada velit purus id a '
    }
]
export default data;